import React, { useEffect, useRef } from 'react';
import { GPTPreviewType } from '../../types';
import GPT from '@op/components/GPT';
import './index.scss';
import { commonBackInfo } from '../../utils';
import GptOptions from '@op/pages/AIAnalysisHub/KeywordAndURLAnalysis/component/Filter/KeywordUrlFilter/components/GptOptions';
import { useFilterPromptInfo } from '@op/pages/AIAnalysisHub/KeywordAndURLAnalysis/hook';

export default function GPTPreview({
  defaultValue,
  filterValue,
  onChange,
  gameInfo,
  wholeGameInfo,
  promptList,
  videoPromptList,
  tab = 'url',
  dynamicsConfig,
}: GPTPreviewType) {
  const {
    promptInfo,
    setPromptInfo,
    videoPromptInfo,
    commentsPromptInfo,
    keywordPromptInfo,
    visible,
    toggleVisible,
    initPromptInfo,
    modalTitle,
    gptType,
    setGptType,
    advancedLimitLoading,
    gptList,
    setGptList,
    realPromptList,
    getPromptInfo,
    isAdvanced,
  } = useFilterPromptInfo({
    tab,
    wholeGameInfo,
    gameInfo,
    promptList,
    videoPromptList,
    needRequest: false,
  });
  const isFirst = useRef(true);

  useEffect(() => {
    const { promptInfo, model_type } = defaultValue;

    if (promptInfo && isFirst.current) {
      initPromptInfo(defaultValue);
      setGptList(defaultValue.gptList || ['comments']);
      setGptType(model_type || "gpt");
    }

    isFirst.current = false;
  }, []);

  useEffect(() => {
    const { promptInfo, model_type } = filterValue;

    if (promptInfo && !isFirst.current) {
      initPromptInfo(filterValue);
      setGptType(model_type || "gpt");
    }
  }, [filterValue]);

  useEffect(() => {
    onChange?.(
      'GptPreview',
      commonBackInfo(
        {
          promptInfo: getPromptInfo(),
          gptList,
        },
        { GptPreview: promptInfo },
      ),
    );
  }, [promptInfo]);

  return (
    <div className="gpt-preview-wrapper">
      <GptOptions
        remainder={dynamicsConfig?.remainder}
        total={dynamicsConfig?.total}
        gptType={gptType}
        setGptType={setGptType}
        toggleVisible={toggleVisible}
        setPromptInfo={setPromptInfo}
        videoPromptInfo={videoPromptInfo}
        commentsPromptInfo={commentsPromptInfo}
        keywordPromptInfo={keywordPromptInfo}
        advancedLimitLoading={advancedLimitLoading}
        gptList={gptList}
        setGptList={setGptList}
        tab={tab}
      ></GptOptions>

      <GPT.PromptModalSimple
        visible={visible}
        close={() => toggleVisible()}
        handleConfirm={(data) => {
          const { prompt, ...otherInfo } = data;
          const key = isAdvanced ? 'advancedPrompt' : 'prompt';
          setPromptInfo(
            { ...promptInfo, ...otherInfo, [key]: prompt },
            tab === 'keyword' ? tab : undefined,
          );
          toggleVisible();
        }}
        title={modalTitle}
        promptList={realPromptList}
        gptType={gptType}
        isAdvanced={isAdvanced}
        defaultPromptText={
          isAdvanced ? promptInfo?.advancedPrompt : promptInfo?.prompt
        }
        defaultActive={promptInfo?.prompt ? -1 : 1}
      ></GPT.PromptModalSimple>
    </div>
  );
}
